import { render } from "./ContabilitaPage.vue?vue&type=template&id=59e63a8a&scoped=true"
import script from "./ContabilitaPage.vue?vue&type=script&lang=js"
export * from "./ContabilitaPage.vue?vue&type=script&lang=js"

import "./ContabilitaPage.vue?vue&type=style&index=0&id=59e63a8a&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e63a8a"]])

export default __exports__